import { SashaServiceBase, WsSasha } from "./wsdl/WsSasha/v1.01/WsSasha.ts";

export {
    WsSasha
};

export class SashaService extends SashaServiceBase {
}